import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AuthInitialState {
  email: null | string;
}

const initialState: AuthInitialState = {
  email: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthEmail: (state, { payload }: PayloadAction<string>) => {
      state.email = payload;
    },
  },
});

export const { setAuthEmail } = authSlice.actions;
export default authSlice.reducer;
